import { AppConstatnt } from "./AppConstant";
import { toast } from 'react-toastify';
import { parsePhoneNumberWithError } from "libphonenumber-js";

const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});


const currencyConvertor = (amount) => formatter.format(amount);
let toastOptions = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: 0,
    type: 'error'
};


function dollarToCents(amount) {
    const cents = amount * 100;
    return cents;
}

function setTheme(value) {
    localStorage.setItem('theme', value);
}

function getTheme() {
    let theme = localStorage.getItem('theme');
    if (!theme) {
        theme = AppConstatnt.theme.DARK;
        localStorage.setItem('theme', theme);
    }
    return theme;
}

function setValueLocalStorage(key, value) {
    localStorage.setItem(key, value);
}

function getValueLocalStorage(key) {
    let getValue = localStorage.getItem(key);
    if (!getValue) {
        return null;
    }
    return getValue;
}

function getRecentTruckPayment() {
    const getValue = localStorage.getItem('recentPayment');
    if (!getValue) {
        return [];
    }
    return JSON.parse(getValue);
}

function setRecentTruckPayment(value) {
    let vl = [];
    if (value) {
        vl = value
    }
    vl = JSON.stringify(vl)
    localStorage.setItem('recentPayment', vl);
}


function isValidString(input) {
    const regex = /^[a-zA-Z ]*$/;
    return regex.test(input);
}

function isValidCompanyName(input) {
    const regex = /^[a-zA-Z& ]*$/;
    return regex.test(input);
}


function isValidEmail(input) {
    // const Emailcheck = /^[a-zA-Z0-9.]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/
    const Emailcheck = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return Emailcheck.test(input)
}

function isValidCard(input) {
    const MASTERCARD = /^5[1-5][0-9]{1,}|^2[2-7][0-9]{1,}$/;
    const VISA = /^4[0-9]{2,}$/;
    const AMERICANEXPRESS = /^3[47][0-9]{5,}$/;
    const DISCOVER = /^6(?:011|5[0-9]{2})[0-9]{3,}$/;
    //const DINERSCLUB = /^3(?:0[0-5]|[68][0-9])[0-9]{4,}$/;
    //const JCB = /^(?:2131|1800|35[0-9]{3})[0-9]{3,}$/;
    const isMasterCard = MASTERCARD.test(input);
    const isVisa = VISA.test(input);
    const isAmericanExpress = AMERICANEXPRESS.test(input);
    const isDiscover = DISCOVER.test(input);
    // const isDinersClub = DINERSCLUB.test(input);
    //const isJcb = JCB.test(input);
    let isCreditCard = false;
    if (isMasterCard || isVisa || isAmericanExpress || isDiscover) {
        isCreditCard = true;
    }
    return isCreditCard;
}

function formatPhone(mobileNumber) {
    let phone = mobileNumber;
    if (!phone.includes('+')) {
        phone = `+${phone}`;
    }
    return phone;
}

function removeSymbolFromPhone(phone) {
    if (phone.includes('+')) {
        return phone.substring(1);
    }
    return phone;
}

function showAlert(type, message) {

    const autoClose = type !== toast.TYPE.ERROR;
    toastOptions.autoClose = autoClose;
    toastOptions.type = type;

    const toastId = toast(message, toastOptions);

    return toastId;

}

function stickyInfoAlert(type, message) {

    const autoClose = type !== toast.TYPE.INFO;
    toastOptions.autoClose = autoClose;
    toastOptions.type = type;

    const toastId = toast(message, toastOptions);

    return toastId;

}

function isToastActive(id) {
    return toast.isActive(id);
}

function getControlNumber() {
    let controlNumber = localStorage.getItem('controlNumber');
    if (!controlNumber) {
        return null;
    }
    return controlNumber;
}

function setControlNumber(controlNumber) {
    localStorage.setItem('controlNumber', controlNumber);
}

function registerCarrierEnteredMobileNumber(mobileNumber) {
    const phone = formatPhone(mobileNumber);
    localStorage.setItem('carrierEnteredPhone', phone);
}

function getCarrierEnteredMobileNumber() {
    return localStorage.getItem('carrierEnteredPhone');
}

function setApplicationFlow(flow) {
    localStorage.setItem('Flow', flow);
}

function getApplicationFlow() {
    return localStorage.getItem('Flow');
}

function dynamicRegex(value, input) {
    let pattern = '';
    var reg;
    let num = '[0-9]';
    let alpha = '[A-Z]';
    for (let i = 0; i < value.length; i++) {
        if (value[i] === '#') {
            pattern += num + '{1}';
        }
        else if (value[i] === '@') {
            pattern += alpha + '{1}';
        }

    }

    reg = new RegExp('^' + pattern + '$');
    const result = reg.test(input);
    return result;
}

const validateComdataPreEditRange = (data, enteredData) => {
    try {
        const startRange = Number(data.substring(0, 6).trim())
        const endRange = Number(data.substring(6, 12).trim())
        if (enteredData >= startRange && enteredData <= endRange) {
            return true
        }
        return false
    } catch {
        return false
    }
}

function TranslateAccent(name) {
    return name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

const comCheckAdditionalFields = new Map();
comCheckAdditionalFields.set("driver_num", "Driver Number");
comCheckAdditionalFields.set("trailer_num", "Trailer Number");
comCheckAdditionalFields.set("hub_reading", "Hub Reading");
comCheckAdditionalFields.set("trailer_hub", "Trailer Hub");
comCheckAdditionalFields.set("trailer_hours", "Trailer Hours");
comCheckAdditionalFields.set("trip_num", "Trip Number");
comCheckAdditionalFields.set("driver_license_num", "Driver License Number");
comCheckAdditionalFields.set("driver_license_state", "Driver License State");
comCheckAdditionalFields.set("po_num", "PO Number");

const comCheckFuelCardFieldValidation = new Map();

const comCheckFuelCardSeries = [556736, 560017, 556735, 555622];

const customStylesDark = {
    control: (base, state) => ({
        ...base,
        background: "#404954",
        border: '1px solid #e6e6e6',
        color: '#e3eaef',
        minHeight: '42px',

        // match with the menu
        //   borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
        // Overwrittes the different states of border
        // Removes weird border around container
        "&:hover": {
            // Overwrittes the different states of border
            borderColor: '#404954',
            color: '#e3eaef'
        }
    }),
    menu: base => ({
        ...base,
        // override border radius to match the box
        borderRadius: 0,
        background: "#404954",
        color: '#e3eaef',
        // kill the gap
        marginTop: 0
    }),
    menuList: base => ({
        ...base,
        // kill the white space on first and last option
        background: "#404954",
        color: '#e3eaef',
        padding: 0,

    }),
    option: (base, state) => ({
        ...base,
        // kill the white space on first and last option
        background: "#404954",
        color: '#e3eaef',
        "&:hover": {
            // Overwrittes the different states of border
            background: "#68696b6b"
        }
    }),
    singleValue: base => ({
        ...base,
        color: '#e3eaef'
    }),
    input: base => ({
        ...base,
        color: '#e3eaef'
    })
};
const customStylesLight = {
    control: (base, state) => ({
        ...base,
        background: "#fff",
        border: '1px solid #e6e6e6',
        color: '#000',
        minHeight: '42px',

        // match with the menu
        //   borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
        // Overwrittes the different states of border
        // Removes weird border around container
        "&:hover": {
            // Overwrittes the different states of border
            borderColor: '#404954',
            color: '#000'
        }
    }),
    menu: base => ({
        ...base,
        // override border radius to match the box
        borderRadius: 0,
        background: "#fff",
        color: '#000',
        // kill the gap
        marginTop: 0
    }),
    menuList: base => ({
        ...base,
        // kill the white space on first and last option
        background: "#fff",
        color: '#000',
        padding: 0,

    }),
    option: (base, state) => ({
        ...base,
        // kill the white space on first and last option
        background: "#fff",
        color: '#000',
        "&:hover": {
            // Overwrittes the different states of border
            background: "#68696b6b"
        }
    }),
    singleValue: base => ({
        ...base,
        color: '#000'
    }),
    input: base => ({
        ...base,
        color: '#000'
    })
};

function browserDetect() {
    let browserName = 'unknown'
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        browserName = 'Opera';
    }
    else if (navigator.userAgent.indexOf("Edg") != -1) {
        browserName = 'Edge';
    }
    else if (navigator.userAgent.indexOf("Chrome") != -1) {
        browserName = 'Chrome';
    }
    else if (navigator.userAgent.indexOf("Safari") != -1) {
        browserName = 'Safari';
    }
    else if (navigator.userAgent.indexOf("Firefox") != -1) {
        browserName = 'Firefox';
    }
    else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
    {
        browserName = 'IE';
    }
    return browserName;
}

function filterBilledLoads(el, billedData) {
    let filterData = billedData.billedPo.loads.filter((item) => item.load_control_num === el.load_control_num);
    // if(filterData.length){
    //     filterData = filterData[0]
    // }
    return filterData;
}

function filterRecentPayment(el) {
    const recentPayment = getRecentTruckPayment()
    let filterData = []
    if (recentPayment.length) {
        filterData = recentPayment.filter((item) => item.load_control_num === el.load_control_num);
    }
    return filterData;
}

const getActiveCountryCode = (countryList) => {
    const activeCountriesListCodes = countryList && countryList.filter((el) => {
        return el.data_status === "ACTIVE"
    }).map((el) => {
        return el.short_name.toLowerCase()
    })
    return activeCountriesListCodes
}

const captchaImageDataSet1 = [
    {
        id: "bus1",
        src: "https://remotepaymentapp-bucket195058-dev.s3.us-west-2.amazonaws.com/captchaImages/bus1.jpg"
    },
    {
        id: "car1",
        src: "https://remotepaymentapp-bucket195058-dev.s3.us-west-2.amazonaws.com/captchaImages/car1.jpg"
    },
    {
        id: "truck1",
        src: "https://remotepaymentapp-bucket195058-dev.s3.us-west-2.amazonaws.com/captchaImages/truck1.jpg"
    },
    {
        id: "bike1",
        src: "https://remotepaymentapp-bucket195058-dev.s3.us-west-2.amazonaws.com/captchaImages/bike1.jpg"
    }
]

const captchaImageDataSet2 = [
    {
        id: "truck1",
        src: "https://remotepaymentapp-bucket195058-dev.s3.us-west-2.amazonaws.com/captchaImages/truck2.jpg"
    },
    {
        id: "bus1",
        src: "https://remotepaymentapp-bucket195058-dev.s3.us-west-2.amazonaws.com/captchaImages/bus2.jpg"
    },
    {
        id: "bike1",
        src: "https://remotepaymentapp-bucket195058-dev.s3.us-west-2.amazonaws.com/captchaImages/bike2.jpg"
    },
    {
        id: "car1",
        src: "https://remotepaymentapp-bucket195058-dev.s3.us-west-2.amazonaws.com/captchaImages/car2.jpg"
    }
]

const getAttributeToVerify = () => {
    if (getApplicationFlow() === AppConstatnt.flow.DRIVER) {
        return "phone_number"
    }
    return "email"
}

const getTruckSource = (data) => data?.truckSource || "FS"

const isEclipseOpsTruck = (data) => {
    return getTruckSource(data) === "eclipseOps" ? true : false
}

const getPONumber = (item) => {
    const po = item?.pos[0].po_number || "-"
    return `PO:${po}`
}

function getCountryCode(phoneNumber) {
    try {
        const parsed = parsePhoneNumberWithError(phoneNumber);
        return `+${parsed.countryCallingCode}`;
    } catch (error) {
        console.error("Invalid phone number:", error.message);
        return null;
    }
}

function getMobileNumber(phoneNumber) {
    try {
        const parsed = parsePhoneNumberWithError(phoneNumber); // Use parsePhoneNumberWithError instead
        return parsed.nationalNumber; // Returns the mobile number without country code
    } catch (error) {
        console.error("Invalid phone number:", error.message);
        return null;
    }
}

const getMode = (type) => {
    if (type === "RELAY") {
        return "RELAY_EPAY"
    }
    else if (type === "COMDATA") {
        return "COMCHEK_EPAY"
    }
    else if (type === "EFS") {
        return "EFS_EPAY"
    }
    else if (type === "TCHEK") {
        return "T-CHEK_EPAY"
    }
    else if (type === "INSTAMONEY") {
        return "INSTA-MONEY"
    }
    else if (type === "USBANK") {
        return "US BANK"
    }
    else if (type === "CREDITCARD") {
        return "CreditCard"
    }
}

export {
    currencyConvertor,
    dollarToCents,
    getTheme,
    setTheme,
    isValidString,
    showAlert,
    formatPhone,
    removeSymbolFromPhone,
    getControlNumber,
    setControlNumber,
    registerCarrierEnteredMobileNumber,
    getCarrierEnteredMobileNumber,
    setApplicationFlow,
    getApplicationFlow,
    isValidEmail,
    isToastActive,
    toastOptions,
    isValidCard,
    comCheckAdditionalFields,
    comCheckFuelCardFieldValidation,
    dynamicRegex,
    comCheckFuelCardSeries,
    isValidCompanyName,
    stickyInfoAlert,
    TranslateAccent,
    customStylesDark,
    customStylesLight,
    browserDetect,
    setValueLocalStorage,
    getValueLocalStorage,
    getRecentTruckPayment,
    setRecentTruckPayment,
    filterBilledLoads,
    filterRecentPayment,
    getActiveCountryCode,
    captchaImageDataSet1,
    captchaImageDataSet2,
    getAttributeToVerify,
    validateComdataPreEditRange,
    isEclipseOpsTruck,
    getPONumber,
    getCountryCode,
    getMobileNumber,
    getMode
};